// Real client testimonials provided by the business owner are rendered on
// service pages. This file intentionally starts EMPTY: never invent quotes,
// names or reviews. Format when real quotes arrive:
// { quote: "...", author: "First name / role", org: "Company or city", service: "mobile-patrol-security" }
export const TESTIMONIALS = [];
